import { TransType } from "system/translations/types";
import { PaymentOption, PaymentType } from "./types";

export const paymentTypeOptions = (_t: TransType): PaymentOption[] => [
  { label: _t("deposit"), value: PaymentType.DEPOSIT },
  { label: _t("withdrawal"), value: PaymentType.WITHDRAWAL },
];
